import { useEffect, useState } from 'react';

/**
 * Custom hook to fetch data from server
 * @param route The function from routes.js for the route to call
 * @param options Any options to pass to the route
 * @param dependencies Hook dependencies, pass empty array for onMount
 */
export const useRoute = <T>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  route: (opts: Record<string, any>) => string,
  // These are options that are passed to the `route` fn
  options: object,
  // This is a body that is passed directly to fetch
  body: RequestInit['body'],
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  dependencies: Array<any>,
) => {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const opts = { ...options, subdomain_param: 'api' };

  useEffect(() => {
    setLoading(true);

    fetch(route(opts), { body: body, credentials: 'include' })
      .then((res) => res.json())
      .then(setData)
      .catch(setError)
      .finally(() => setLoading(false));
    // Intentional here - passthrough
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  return { data, error, loading };
};
